import { render } from "./systemOperate.vue?vue&type=template&id=008f9c3d&scoped=true"
import script from "./systemOperate.vue?vue&type=script&lang=js"
export * from "./systemOperate.vue?vue&type=script&lang=js"

import "./systemOperate.vue?vue&type=style&index=0&id=008f9c3d&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008f9c3d"]])

export default __exports__